import React from 'react';

const PortfolioIcon = () => (
    <div className='PortfolioIcon DesktopIcon'>
        <img
            // src='/images/PortfolioIcon.png'
            src='/images/Finalized/PortfolioIcon.png'
            alt='Portfolio'
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        />
        <span>Portfolio</span>
    </div>
);

export default PortfolioIcon;
